import { atomWithReset } from "jotai/utils";

export const helpAtom = atomWithReset({
  isFocused: false,
  helpSection: {
    title: "",
    description: "",
    type: "",
    other: "",
  },
});
